import { Injectable } from '@angular/core';
import { ExportFormat } from '../../../models/influencer-export';
import { BackendHttpService } from '../../core/backend-http.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Injectable()
export class ExportInfluencerService extends BackendHttpService<any> {

  constructor(protected router: Router,
    protected translate: TranslateService) {
    super(router, translate);
  }

  private inferFileName(mimeType: string, fileName: string): string {
    fileName += '.';

    switch (mimeType) {
      case 'application/vnd.ms-excel':
        fileName += 'xls';
        break;
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        fileName += 'xlsx';
        break;
    }
    if (mimeType.startsWith('application/pdf')) {
      fileName += 'pdf';
    }

    return fileName;
  }

  public exportInfluencer({ format }: ExportFormat, { url, options = {} }: { url: string, options?: object }, fileName: string, setIsLoading: Function) {
    this.handleLoading(setIsLoading, true);
    return this.getBlob(
      url,
      {
        headers: { 'Content-Type': 'application/' + format },
        params: { format, ...options }
      }
    ).subscribe((blob: Blob) => {
      const _fileName = this.inferFileName(blob.type, fileName);
      this.handleExcelDownload(blob, _fileName);
      this.handleLoading(setIsLoading, false);
    },
      () => this.handleLoading(setIsLoading, false),
      () => this.handleLoading(setIsLoading, false));
  }

  private handleExcelDownload(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove(); // Clean up the DOM
  }

  private handleLoading(isLoading: Function, status: boolean) {
    return typeof isLoading === 'function' && isLoading(status);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/services/export-influencer.service.ts